import { useState, useEffect } from 'react';
import ProtocolPurchaseBody from '../components/marketplace/protocolPurchaseBody';

const ProtocolPurchase = () => {
  const [purchaseType, setPurchaseType] = useState<string>('');
  useEffect(() => {
    if (window.location.pathname.includes('dedicated-node')) {
      setPurchaseType('dedicatedNode');
    } else {
      setPurchaseType('stakingNode');
    }
  }, []);
  return (
        <>
            <ProtocolPurchaseBody purchaseType={purchaseType} />
        </>
  );
};

export default ProtocolPurchase;